import { SORT_ORDER } from '@evinced-private/ui-common';

import { removeSelectAllOption } from 'src/common/helpers/GQLRequestsHelper/removeSelectAllOption';

import {
	DEFAULT_PAGE,
	DEFAULT_PAGE_SIZE,
	MIN_ISSUES_FOR_VISIBLE_SCAN
} from '../MobileScansList.constants';
import {
	IGetMobileScansListParams,
	IMobileScansListVariables,
	MobileScansListSortFields,
	MobileScansListSortOrder
} from '../MobileScansList.types';

const SORT_FIELDS_MAP: Record<string, MobileScansListSortFields> = {
	scanCreatedAt: MobileScansListSortFields.ScanCreatedAt,
	scanName: MobileScansListSortFields.ScanName,
	totalIssues: MobileScansListSortFields.TotalIssues,
	criticalIssues: MobileScansListSortFields.CriticalIssues,
	seriousIssues: MobileScansListSortFields.SeriousIssues,
	elementsWithIssues: MobileScansListSortFields.ElementsWithIssues
};

const SORT_ORDER_MAP: Record<SORT_ORDER, MobileScansListSortOrder> = {
	[SORT_ORDER.ASC]: MobileScansListSortOrder.Ascending,
	[SORT_ORDER.DESC]: MobileScansListSortOrder.Descending
};

export const buildMobileScansListVariables = ({
	runId,
	includeScansWithoutIssues = false,
	sort,
	page = DEFAULT_PAGE,
	pageSize = DEFAULT_PAGE_SIZE,
	filterOptions
}: IGetMobileScansListParams): IMobileScansListVariables => {
	const variables: IMobileScansListVariables = {
		runId: { value: [runId] },
		offset: (page - 1) * pageSize,
		limit: pageSize
	};

	if (!includeScansWithoutIssues) {
		variables.totalIssuesMinFilter = { value: [MIN_ISSUES_FOR_VISIBLE_SCAN] };
	}

	const scanNames = removeSelectAllOption(filterOptions?.scans ?? []).map(({ label }) => label);
	if (scanNames.length) {
		variables.scanNameFilter = { value: scanNames };
	}

	const searchValue = filterOptions?.searchValue;
	if (searchValue) {
		variables.textSearch = {
			insensitive: true,
			searchFields: [MobileScansListSortFields.ScanName],
			searchValues: [searchValue]
		};
	}

	const sortField = sort?.dataField ? SORT_FIELDS_MAP[sort.dataField] : undefined;
	const sortOrder = sort?.order ? SORT_ORDER_MAP[sort.order] : undefined;

	if (sortField) {
		variables.sort = {
			fields: [sortField],
			...(sortOrder ? { order: sortOrder } : {})
		};
	}

	return variables;
};
